<template>
    <div class="map-left">
        <boxTitle :title="'综合态势'" :subtitle="'Overview'"></boxTitle>
        <divBox class="all-round">
            <template>
                <div>
                    <boxList :list="allRoundData" :line="2"></boxList>
                </div>
            </template>
        </divBox>

        <div class="power-chart mt-50">
            <divBox :title="'充换电次数'">
                <template>
                    <leftcharts
                        v-if="leftchartsShow"
                        :id="'leftMapchangdiancishu'"
                        :xAxis="xAxis"
                        :colors="['#3FFFD9', '#60F5FF']"
                        :yAxis="{name: '充换电次数'}"
                        :series="[exchangeOrChargeNum]" />
                </template>
            </divBox>
            <divBox :title="'充换电电量'">
                <template>
                    <leftcharts
                        v-if="leftchartsShow"
                        :id="'leftMapchangdianliang'"
                        :xAxis="xAxis"
                        :yAxis="{name: '充换电电量'}"
                        :series="[exchangeOrChargeElect]" />
                </template>
            </divBox>
        </div>

        <divBox class="mt-50" :title="'乘用车&商用车换电'">
            <template>
                <lefthuandian :data="huandianData" />
            </template>
        </divBox>
    </div>
</template>

<script>
import boxTitle from '../../components/boxTitle.vue'
import divBox from '../../components/divBox.vue'
import boxList from '../../components/boxList.vue'

import leftcharts from './left-charts.vue'
import lefthuandian from './lefthuandian.vue'

import { dataInterface } from '@/api/dataInterfaceApi'
export default {
    components: {
        boxTitle,
        divBox,
        boxList,
        leftcharts,
        lefthuandian
    },
    data() {
        return {
            allRoundData: [
                {
                    icon: 'map',
                    title: '累计充换电站数',
                    value: '366',
                    unit: '座',
                    color: '#43FFB9'
                },
                {
                    icon: 'car',
                    title: '累计充换电车辆',
                    value: '366',
                    unit: '辆',
                    color: '#43FFB9'
                },
                {
                    icon: 'user',
                    title: '累计入网司机数',
                    value: '366',
                    unit: '人',
                    color: '#36FBFB'
                },
                {
                    icon: 'battery',
                    title: '累计充换电电量',
                    value: '366',
                    unit: '万度',
                    color: '#179DFF'
                },
                {
                    icon: 'panel',
                    title: '累计充换电里程',
                    value: '366',
                    unit: '万公里',
                    color: '#179DFF'
                },
                {
                    icon: 'charts',
                    title: '累计充换电次数',
                    value: '366',
                    unit: '万次',
                    color: '#36FBFB'
                }
            ],
            xAxis: {},
            exchangeOrChargeNum: [],
            exchangeOrChargeElect: [],
            leftchartsShow: false,
            huandianData: []
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        // 初始化
        async init() {
            // 累计充换电站数量
            let totalNum = await this.getquanguoTotalNum()
            // 累计入网司机数量
            let totalUserNum = await this.getquanguoTotalUserNum()
            // 累计充换电车辆数/充换电次数/充换电电量/充换电里程
            let leijichonghuandianxinxi = await this.quanguoleijichonghuandianxinxi()
            // 全国-充换电次数充换电电量
            this.chonghuandiancishudianliang()
            // 全国-乘用车商用车换电
            this.chengyonchesahngyonchehuandian()
            
            // debugger
            this.allRoundData[0].value = totalNum.station_num
            this.allRoundData[1].value = leijichonghuandianxinxi.exchangeOrChargeVehicleNum
            this.allRoundData[2].value = totalUserNum.userNum
            this.allRoundData[3].value = (parseFloat(leijichonghuandianxinxi.exchangeOrChargeElect, 10) / 10000).toFixed(0)
            this.allRoundData[4].value = (parseFloat(leijichonghuandianxinxi.exchangeOrChargeMileage, 10) / 10000).toFixed(0)
            this.allRoundData[5].value = (parseFloat(leijichonghuandianxinxi.exchangeOrChargeNum, 10) / 10000).toFixed(0)
        },
        // 累计充换电站数量
        getquanguoTotalNum() {
            return new Promise((resolve, rejiect) => {
                let params = {
                    "enCode": "TiDB-Energy-quanguo-totalNum"
                }
                dataInterface
                    .dataFaceApi(params)
                    .then((res) => {
                        console.log('=========', res)
                        if(!res || !res.length || !res[0]) resolve({})
                        resolve(res[0])
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            })
        },
        // 累计入网司机数量
        getquanguoTotalUserNum() {
            return new Promise( (resolve, rejiect) => {
                let params = {
                    "enCode": "TiDB-Energy-quanguo-totalUserNum"
                }
                dataInterface
                    .dataFaceApi(params)
                    .then((res) => {
                        console.log('=========', res)
                        if(!res || !res.length || !res[0]) resolve({})
                        resolve(res[0])
                    })
                        .catch((err) => {
                        console.log(err);
                    })
            })
        },
        // 累计充换电车辆数/充换电次数/充换电电量/充换电里程
        quanguoleijichonghuandianxinxi() {
            return new Promise( (resolve, reject) => {
                let params = {
                    "enCode": "TiDB-Energy-quanguo-leijichonghuandianxinxi"
                }
                dataInterface
                    .dataFaceApi(params)
                    .then((res) => {
                        console.log('=========', res)
                        if(!res || !res.length || !res[0]) resolve({})
                        resolve(res[0])
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            })
        },
        // 全国-充换电次数充换电电量
        chonghuandiancishudianliang() {
            let params = {
                "enCode": "TiDB-Energy-quanguo-chonghuandiancishudianliang"
            }
            let xdata = []
            let exchangeOrChargeNum = []
            let exchangeOrChargeElect = []
            dataInterface
                .dataFaceApi(params)
                .then((res) => {
                    console.log('chonghuandiancishudianliang=======', res)
                    if(!res || !res.length || !res[0]) return
                    res.map(item => {
                        xdata.push(item.provinceName)
                        exchangeOrChargeNum.push(parseFloat(item.exchangeOrChargeNum, 10))
                        exchangeOrChargeElect.push(parseFloat(item.exchangeOrChargeElect, 10))
                    })
                    // debugger
                    this.xAxis.data = xdata
                    this.exchangeOrChargeNum = exchangeOrChargeNum
                    this.exchangeOrChargeElect = exchangeOrChargeElect
                    this.leftchartsShow = true
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        // 全国-乘用车商用车换电
        chengyonchesahngyonchehuandian() {
            let params = {
                "enCode": "TiDB-Energy-quanguo-chengyonchesahngyonchehuandian"
            }
            let xdata = []
            dataInterface
                .dataFaceApi(params)
                .then((res) => {
                    console.log('chengyonchesahngyonchehuandian=========', res)
                    if(!res || !res.length || !res[0]) return
                    this.huandianData = res
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../comm.scss';
.map-left {
    margin-top: 20px;
    .all-round {
        padding: 15px 0;
        margin-top: 20px;
    }
    .power-chart {
        // margin-top: 6px;
        display: flex;
        > div {
            margin: 0 3px;
            &:first-child {
                margin-left: 0;
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }
    // .power-chart1 {
    //     // margin-top: 6px;
    // }
}
</style>